import { Injectable } from '@angular/core';
import { InventoryFilterRepresentation } from '../inventory-filter-representation';

@Injectable({ providedIn: 'root' })
export class InventoryFilterStateService {
  private filters = new Map<string, InventoryFilterRepresentation>();

    constructor() {
    console.log(
      'InventoryFilterStateService instance created',
      Math.random()
    );
    }

  /** Get existing filter or create it once */
  getFilter(key: string): InventoryFilterRepresentation {
    if (!this.filters.has(key)) {
      this.filters.set(key, new InventoryFilterRepresentation());
    }
    return this.filters.get(key)!;
  }

  /** Explicitly overwrite a filter */
  setFilter(key: string, filter: InventoryFilterRepresentation): void {
    this.filters.set(key, filter);
  }

  /** Remove one filter */
  clearFilter(key: string): void {
    this.filters.delete(key);
  }

  /** Reset all filters (optional) */
  clearAll(): void {
    this.filters.clear();
  }
}
